import React from 'react';
var AKCheckbox = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.checkbox' */
  '@atlaskit/checkbox').then(function (module) {
    return {
      default: module.Checkbox
    };
  });
});
export var Checkbox = function Checkbox(props) {
  var checkboxProps = props.forgeDoc.props;
  var _onChange = checkboxProps.onChange,
    value = checkboxProps.value,
    key = checkboxProps.key,
    label = checkboxProps.label,
    defaultChecked = checkboxProps.defaultChecked,
    isRequired = checkboxProps.isRequired;
  return /*#__PURE__*/React.createElement(AKCheckbox, {
    key: key,
    label: label,
    defaultChecked: defaultChecked,
    isRequired: isRequired,
    value: value,
    onChange: function onChange(e) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange({
        value: value,
        isChecked: e.target.checked
      });
    }
  });
};